import { lazy, Suspense, type ReactElement } from 'react'
import { WidgetListItems } from '../../util/sidebar'
import Watchlists from '../watchlist/Watchlist'
import TradeWidget from '../TradePanel/tradeWidget'

// Watchlist and trade panel are the usual default views, so they stay in the entry bundle;
// the rest are fetched the first time their tab is opened.
const AlertsSidebar = lazy(() => import('../alerts/alertsSidebar/AlertsSidebar'))
const MarketNews = lazy(() => import('../news/MarketNews'))
const PositionsWidget = lazy(() => import('../postionsWidget'))
const OrdersWidget = lazy(() => import('../ordersWidget'))
const HoldingsWidget = lazy(() => import('../holdings/HoldingsWidget'))
const AiAssistantPanel = lazy(() => import('../aiAssistant/AiAssistantPanel'))
const SupportPanel = lazy(() => import('../support/SupportPanel'))

/** Stable element references so WidgetbarPageShell memo is not broken on parent re-renders. */
export const WIDGETBAR_VIEW_ELEMENTS: Partial<Record<WidgetListItems, ReactElement>> = {
    [WidgetListItems.WATCHLIST]: <Watchlists />,
    [WidgetListItems.ALERT]: <Suspense fallback={null}><AlertsSidebar /></Suspense>,
    [WidgetListItems.MARKET_NEWS]: <Suspense fallback={null}><MarketNews /></Suspense>,
    [WidgetListItems.POSITIONS]: <Suspense fallback={null}><PositionsWidget /></Suspense>,
    [WidgetListItems.TRADE]: <TradeWidget />,
    [WidgetListItems.ORDERS]: <Suspense fallback={null}><OrdersWidget /></Suspense>,
    [WidgetListItems.HOLDINGS]: <Suspense fallback={null}><HoldingsWidget /></Suspense>,
    [WidgetListItems.AI_ASSISTANT]: <Suspense fallback={null}><AiAssistantPanel /></Suspense>,
    [WidgetListItems.SUPPORT]: <Suspense fallback={null}><SupportPanel /></Suspense>,
}
